// Mount ONCE inside the authenticated shell. Installs the delivery scheduler
// and emits a page_view on every route change. No visible UI.

import { useEffect } from 'react'
import { installScheduler } from './queue'
import { usePageView } from './use-page-view'

export function PageViewTracker() {
  useEffect(() => {
    installScheduler()
  }, [])
  usePageView()
  return null
}
